<template>
    <SelectAsync v-model="model" :searchFunction="search" :placeholder="placeholder" :hasError="hasError" @remove="$emit('remove')">
        <template slot="option" slot-scope="props">
            <div>{{ props.option.name }}</div>
            <small class="opacity-5">{{ props.option.email }}</small>
        </template>
        <template slot="singleLabel" slot-scope="props">
            {{ props.option.name }}
        </template>
    </SelectAsync>
</template>

<script>
    import ModelsSelects from '../../../mixins/ModelsSelects'

    export default {
        props: {
            multiple: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Select an user'
            }
        },
        methods: {
            defaultSearch(search) {
                return this.$api.users.get({
                    search: search
                })
            }
        },
        mixins: [
            ModelsSelects
        ]
    }
</script>
